// src/composables/useMapSessionKeepAlive.js
// KR DDAT-104/698 포트 (DDAT-1660): 맵 기반 장시간 표시 화면 전용 세션 keep-alive.
// 30분 주기 + mount 직후 1회 선제 refresh 로 AT(15분)·RT(60분) 를 만료 전에 회전시켜
// 유휴 60분 자동 로그아웃을 막는다. 적용 라우트는 constants/sessionKeepAliveRoutes.js.
import { onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';

import { callRefreshTokenSingleton } from './refreshTokenCallSingleton';

// RT 60분 기준: 30분 간격이면 한 번 실패해도 다음 주기에 회복 기회가 있다.
const INTERVAL_MS = 30 * 60 * 1000;

// module-level 싱글톤 — 다중 맵 인스턴스에서 타이머를 1개만 유지
let mountCount = 0;
let timer = null;

async function ping(store) {
	if (document.visibilityState !== 'visible') return;
	const refreshToken = store.getters['loginModule/getRefreshToken'];
	if (!refreshToken) return;
	try {
		const authUrl = process.env.VUE_APP_API_URL_AUTH;
		// in-flight 싱글톤으로 main.js refresh() 와 동시 호출을 dedup — RT 회전 경합 차단
		const resp = await callRefreshTokenSingleton(authUrl);
		if (resp.data?.success && resp.data?.data) {
			// 토큰만 갱신. main.js refresh() 의 member/detail 재조회·reload 는 의도적 생략.
			// credentialsNonExpired 를 빼면 SET_CREDENTIAL(undefined) 로 로그인 시점 값이 지워진다.
			await store.dispatch('loginModule/saveLoginData', {
				accessToken: resp.data.data.accessToken,
				refreshToken: resp.data.data.refreshToken,
				credentialsNonExpired: store.state.loginModule.credentialsNonExpired,
			});
		}
	} catch {
		// 실패 무시 — 401 은 기존 axios interceptor 가 처리, 네트워크 에러는 다음 폴링 재시도
	}
}

export function useMapSessionKeepAlive() {
	const store = useStore();

	onMounted(() => {
		mountCount++;
		if (mountCount === 1) {
			timer = setInterval(() => ping(store), INTERVAL_MS);
			// 즉시 1회 ping — mount 시점부터 만료 타이머 리셋. ping 은 절대 throw 하지 않는다.
			ping(store);
		}
	});

	onBeforeUnmount(() => {
		mountCount--;
		if (mountCount === 0 && timer !== null) {
			clearInterval(timer);
			timer = null;
		}
	});
}
